export class ShowPlatformDialogMessage {
    public content: any;

    static create(content: any) : ShowPlatformDialogMessage
    {
        let t = new ShowPlatformDialogMessage();
        t.content = content;
        return t;
    }
}

export class ClosePlatformDialogMessage {}